import { useState } from "react";

import { Filters, Sort, Sorts } from "Models/shipeezi.table";
import { handleSort } from "Util/handleSort";
import { ISubscriber } from "Models/shipments";

export const useWaybillNotificationGridConfig = () => {
  const [total, setTotal] = useState<number>(0);
  const [filters, setFilters] = useState<Filters>();
  const [sorting, setSorting] = useState<Sorts>([["updatedAt", "desc"]]);
  const [page, setPage] = useState<number>(0);
  const [pageSize, setPageSize] = useState<number>(20);
  const [pageSizeOptions, setPageSizeOptions] = useState<number[]>([20, 40, 60, 100]);
  const [searchValue, setSearchValue] = useState<string>("");
  const [selectedRowList, setSelectedRowList] = useState<ISubscriber[]>([]);

  const nextPage = () => setPage(page + 1);
  const prevPage = () => setPage(page - 1);
  const handleSorting = (sorts: Sort[]) => {
    setSorting(handleSort(sorts));
  };

  return [
    { total, filters, sorting, page, pageSize, pageSizeOptions, searchValue, selectedRowList },
    {
      setTotal,
      setFilters,
      setSorting,
      setPage,
      setPageSize,
      setPageSizeOptions,
      setSearchValue,
      setSelectedRowList,
      nextPage,
      prevPage,
      handleSorting,
    },
  ];
};
